<template>
  <div class="exam">
    <anav :name="className" @back="back">
      <router-link :to="{ path: '/', query: { promoteCode: promoteCode }}">
        <img src="https://img2.233.com/wx/union/wap/leadaclass/all-icon.png" class="nav-right">
      </router-link>
    </anav>
    <div class="list">
      <div class="box" v-for="item in promoteCourse" :key="item.MyClassID" @click="toDetail(item.MyClassID)">
        <div :class="['left', item.PicPath ? '' : 'align']">
          <img :src="item.PicPath" v-if="item.PicPath">
          <p v-else>暂无图片</p>
        </div>
        <div class="right">
          <h2>{{item.MyClassName}}</h2>
          <p>主讲老师：{{item.Teacher ? item.Teacher : "待定"}}</p>
          <div class="bottom">
            <div class="price">
              <label>免费</label>
              <del v-if="item.GoodPrice !== 0 && item.SingleTF !== 2">¥{{item.GoodPrice}}</del>
            </div>
            <div class="button">
              <label v-if="item.IsBuy === 0" @click.stop="receiving(item.MyClassID)">立即领取</label>
              <label class="led" @click.stop="toAppStudy" v-else>去学习</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ReceivingCourses ref="receivingCourses" :promoteCode="promoteCode"/>
  </div>
</template>

<script>
import anav from "../../components/nav/index"
import ReceivingCourses from "../../components/receivingCourses/index"
import { GetLoginStatus, GetClassName, GetPromoteCourse } from "../../lib/request"
export default {
  name: "Exam",
  components: {
    anav,
    ReceivingCourses
  },
  data() {
    return {
      formList: false,
      promoteCode: "",
      className: "",
      promoteCourse: [],
      loginInfo: {}
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => vm.formList = from.path && from.path !== "/")
  },
  created() {
    if (this.$route.query.promoteCode) {
      this.promoteCode = this.$route.query.promoteCode
    } else {
      location.href = "https://v.233.com/"
    }
  },
  mounted() {
    this.GetClassName()
  },
  methods: {
    GetLoginStatus() {
      if (window.location.href.indexOf("v.233.com") > -1) {
        document.title = this.className ? this.className : "网校学习"
      } else {
        GetLoginStatus({}, (res) => {
          const { Result } = res
          document.title = this.className + (this.className && Result.webName ? "-" : "") + Result.webName
        })
      }
    },
    back() {
      this.formList ? this.$router.go(-1) : this.$router.push({ path: '/', query: { promoteCode: this.promoteCode }})
    },
    GetClassName() {
      GetClassName({ promoteCode: this.promoteCode, classId: parseInt(this.$route.query.id) }, (res) => {
        if (res.Result) {
          this.className = res.Result
          this.GetLoginStatus()
          this.GetPromoteCourse()
        } else {
          this.$router.push({ path: "/", query: { promoteCode: this.promoteCode }})
        }
      })
    },
    GetPromoteCourse() {
      GetPromoteCourse({ promoteCode: this.promoteCode, classId: parseInt(this.$route.query.id) }, (res) => {
        this.promoteCourse = res.Result
      })
    },
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { promoteCode: this.promoteCode, id }})
    },
    receiving(id) {
      this.$refs["receivingCourses"].LoginInfoByPromote(id)
    },
    toAppStudy() {
      location.href = location.host === 'v.233.com' ? "https://www.233.com/shouji233/" : location.origin + "/search/app"
    }
  }
}
</script>

<style lang="scss" scoped>
.exam{
  padding-bottom: 10px;
  .nav-right{
    height: 12px;
    cursor: pointer;
  }
  .list{
    padding: 0 10px;
    .box{
      display: flex;
      justify-content: space-between;
      background: #fff;
      padding: 16px 18px 16px 12px;
      margin-top: 10px;
      border-radius: 6px;
      cursor: pointer;
      .left{
        width: 18%;
        img{
          width: 100%;
          background: #F2F4F3;
          border-radius: 6px;
        }
        p{
          color: #8A8A8A;
          font-size: 12px;
          font-weight: 400;
          text-align: center;
          line-height: 17px;
          padding-top: 3px;
          width: 24px;
          margin: 0 auto;
        }
      }
      .align{
        display: flex;
        align-items: center;
      }
      .right{
        width: calc(82% - 14px);
        h2{
          font-size: 16px;
          color: #333;
          font-weight: 800;
          line-height: 22px;
          display: -webkit-box;
          overflow: hidden;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        p{
          color: #8A8A8A;
          font-weight: 400;
          font-size: 12px;
          line-height: 12px;
          margin: 9px 0 18px;
        }
        .bottom{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .price{
            line-height: 16px;
            label{
              font-size: 16px;
              color: #E13B29;
              font-weight: 400;
            }
            del{
              color: #8A8A8A;
              font-size: 12px;
              font-weight: 400;
              margin-left: 8px;
            }
          }
          .button{
            label{
              display: inline-block;
              width: 80px;
              height: 30px;
              background: linear-gradient(45deg, #FB5D37 0%, #E13A34 99%);
              border-radius: 15px;
              color: #fff;
              font-size: 14px;
              font-weight: 800;
              line-height: 30px;
              text-align: center;
            }
            .led{
              color: #E13A34;
              border: 1px solid #E13A34;
              background: #fff;
              line-height: 28px;
              box-sizing: border-box;
            }
          }
        }
      }
    }
  }
}
</style>